// @vendors
const Immutable = require('immutable');

// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = () => {
    return Immutable.Map().merge({
        hasUnconsolidatedContract: false
    });
};

function brokerCustomWalletNotifications(state = initialState(), action) {
    switch (action.type) {
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_BY_PORTFOLIO_SUCCESS:
        case actionTypes.BROKER_CUSTOM_WALLET_CONTRACT_LIST_SUCCESS:
            const contracts = action.payload;
            const unconsolidatedContract = contracts.find( contract => {
                return !contract.personalizable
            });
            const hasUnconsolidatedContract = unconsolidatedContract ? true : false;
            return state.merge({
                hasUnconsolidatedContract: hasUnconsolidatedContract
            });
        default:
            return state;
    }
}

module.exports = brokerCustomWalletNotifications;
